module.exports = {
      id: "ef33ed0c0fa2de74dfb16f0bc2c021e7construction-prefab-wood.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#ef33ed0c0fa2de74dfb16f0bc2c021e7construction-prefab-wood.svg",
      toString: function () {
        return this.url;
      }
    }